import PatchNotesProvider from './contexts/PatchNotes/Provider'
import Component from './Component'

export default function PatchNotesButton({ setHaveNotification }: any) {
  return (
    <PatchNotesProvider>
      <Component setHaveNotification={setHaveNotification} />
    </PatchNotesProvider>
  )
}
